export default __webpack_public_path__ + "static/media/APLSS Logo Variants-02.5f44697b.png";